import { Star, ExternalLink } from "lucide-react";
import { Chapter, SectionTitle, Reveal } from "./Reveal";
import { GOOGLE_MAPS_URL } from "@/data/content";

const REVIEWS = [
  {
    name: "Tamara S.",
    text: "Il Texan brisket era così morbido da sciogliersi al tocco della forchetta. Atmosfera accogliente, servizio gentile e professionale. John Tartarino è uno di quei posti che consigli senza esitazione.",
  },
  {
    name: "Fabio F.",
    text: "Un'isola tra un mare di proposte di pesce. Le costine di manzo a lunga cottura erano qualcosa di spettacolare. La carta dei vini propone belle etichette. Servizio impeccabile.",
  },
  {
    name: "Clouth B.",
    text: "Fiorentina squisita, tenerissima e saporita. Personale gentile e veloce. Posto molto curato.",
  },
  {
    name: "Marcello C. A.",
    text: "Carne da perfezionista. Una tartare su midollo d'osso deliziosa. Vino ottimo.",
  },
];

const Stars = () => (
  <span className="flex gap-1">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={14} className="text-[#C5A059]" fill="#C5A059" strokeWidth={0} />
    ))}
  </span>
);

const Reviews = () => (
  <section id="recensioni" data-testid="reviews-section" className="relative py-24 sm:py-36 bg-[#141210]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Chapter number="09" title="Dicono di Noi" />
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
        <SectionTitle>
          Parola di chi si è seduto
          <span className="italic text-[#C5A059]"> ai nostri tavoli.</span>
        </SectionTitle>
        <Reveal delay={0.15}>
          <div className="flex items-center gap-8">
            <div data-testid="google-rating-badge">
              <span className="font-cinzel text-5xl text-[#F7F4EE]">4,7</span>
              <div className="mt-2"><Stars /></div>
              <span className="mt-2 block text-[11px] uppercase tracking-[0.2em] text-[#C5BCAD]">
                Google · 160 recensioni
              </span>
            </div>
            <div className="h-16 w-px bg-[#C5A059]/25" />
            <div data-testid="tripadvisor-rating-badge">
              <span className="font-cinzel text-5xl text-[#F7F4EE]">4,4</span>
              <div className="mt-2"><Stars /></div>
              <span className="mt-2 block text-[11px] uppercase tracking-[0.2em] text-[#C5BCAD]">
                TripAdvisor
              </span>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.08}>
            <figure
              data-testid={`review-card-${i}`}
              className="h-full flex flex-col border border-[#F7F4EE]/10 hover:border-[#C5A059]/40 bg-[#1C1917] p-7 transition-colors duration-300"
            >
              <Stars />
              <blockquote className="mt-5 flex-1 font-display text-[17px] leading-relaxed text-[#F7F4EE]/90">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-6 flex items-center justify-between">
                <span className="text-sm text-[#C5A059]">{r.name}</span>
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#C5BCAD]/60">
                  Recensione Google
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-10">
        <a
          data-testid="reviews-google-link"
          href={GOOGLE_MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-[#C5A059] hover:text-[#F7F4EE] transition-colors duration-300"
        >
          Leggi tutte le recensioni su Google
          <ExternalLink size={14} />
        </a>
      </Reveal>
    </div>
  </section>
);

export default Reviews;
